<template >
  <div class="card-default">
    <div class="card-default__container">
      <div class="card-default__header">
        <span v-if="icon" class="card-default__header-icon">
          <ion-icon :name="icon"/>
        </span>
        <div class="card-default__header-text">
          <span class="card-default__header-title">
          {{ title }}
          </span>
          <span v-if="description" class="card-default__header-description">
            {{ description }}
          </span>
        </div>
      </div>

      <div class="card-default__container-body">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>

export default {
name: "support-tools",
props: {
  title: {
    type: String,
    default: "Default Card Title"
  },
  description: {
    type: String,
    default: ""
  },
  icon: {
    type: String,
    default: ""
  }
},
data() {
  return {}
},
methods: {}
}
</script>

<style lang="scss">

* {
  font-family: "Montserrat", sans-serif !important;
}

.card-default {
  padding: 36px 40px;

  &__container {
    border-radius: 16px !important;
    padding: 24px;
    background: #FFF;

    &-body {
      box-sizing: border-box;
      display: flex;
      flex-flow: wrap;
      width: 100%;
    }
  }

  &__header {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 8px;
    padding-bottom: 28px;
    margin-bottom: 28px;
    border-bottom: 1px solid rgba(58,66,78,.0509803922);

    &-text {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    &-icon {
      display: flex;
      font-size: 32px!important;
      color: #1b59f8;
    }

    &-title {
      color: #3a424e;
      font-size: 28px;
      font-style: normal;
      font-weight: 600;
      line-height: 125.303%;
    }

    &-description {
      color: #3a424e;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 125%;
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/vue/pages/components/layouts/cardDefault/index.vue